import { type StateKey, type TransferState } from '@angular/core';
import { type Observable, startWith, tap } from 'rxjs';

export const handleServerState = <T>(
    transferState: TransferState,
    stateKey: StateKey<T>,
    isServer: boolean,
): ((source$: Observable<T>) => Observable<T>) => (source$: Observable<T>) => {
    if (isServer) {
        return source$.pipe(tap(data => {
            transferState.set(stateKey, data);
        }));
    }

    if (transferState.hasKey(stateKey)) {
        return source$.pipe(
            startWith(transferState.get<T>(stateKey, {} as T)),
            tap(() => {
                transferState.remove(stateKey);
            }),
        )
    }

    return source$
}
